export const MuiLinearProgress = (palette) => {
    return { root: { color: palette.semantic.colorPrimary } };
};
